import { put } from "@redux-saga/core/effects";
import { setLogs } from "../../reducers/logReducer";
import moment from "moment";
import { LogApi } from "../../../generated/api";
import { getAPIConfig } from "../../../util/api-config";
import store from "../../configureStore";
import { handleError } from "../../../util/errorHandler";
import { setLoading } from "../../reducers/loadingReducer";

function setUpClient() {
  return new LogApi(getAPIConfig(store.getState().settings.internalSettings));
}

export function* handleGetLogs(action: any): any {
  try {
    const logClient = setUpClient();
    yield put(setLoading(true));
    const params = action.getLogs;
    const pageable = action.pageable;
    const response = yield logClient.getLogsWithParameters(
      params.id,
      params.logTarget,
      params.actions,
      params.dateFrom,
      params.dateTo,
      pageable.size,
      pageable.page,
      pageable.sort
    );
    yield put(setLogs(response));
  } catch (error) {
    yield handleError(error);
  }finally {
    yield put(setLoading(false));
  }
}

export function* handleGetLogReportAsPdf(action: any): any {
  try {
    const logClient = setUpClient();
    const params = action.getLogs;
    const response = yield logClient.getLogsAsPDF(
      params.id,
      params.logTarget,
      params.actions,
      params.dateFrom,
      params.dateTo
    );
    const FileSaver = require("file-saver");
    const datetime = moment().format("yyyy-MM-YYYY HH:mm:ss");
    const blob = new Blob([response], {
      type: "application/pdf;charset=utf-8",
    });
    FileSaver.saveAs(blob, "EFK-Log-Report " + datetime);
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleGetLogReportAsXml(action: any): any {
  try {
    const logClient = setUpClient();
    const params = action.getLogs;
    const response = yield logClient.getLogsAsXML(
      params.id,
      params.logTarget,
      params.actions,
      params.dateFrom,
      params.dateTo
    );
    const FileSaver = require("file-saver");
    const datetime = moment().format("DD/MM/YYYY HH:mm:ss");
    const blob = new Blob([response], {
      type: "application/zip;charset=utf-8",
    });
    FileSaver.saveAs(blob, "EFK-Log-Report " + datetime);
  } catch (error) {
    yield handleError(error);
  }
}
